import { render, staticRenderFns } from "./FormaPagamento.vue?vue&type=template&id=5c80dc21&scoped=true"
import script from "./FormaPagamento.vue?vue&type=script&lang=js"
export * from "./FormaPagamento.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamento.vue?vue&type=style&index=0&id=5c80dc21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80dc21",
  null
  
)

export default component.exports